<template>
  <div>
    <div class="search-wrap" style="margin-top: 5px">
      <div class="spacing">
        <el-input size="mini" placeholder="请输入流程ID"  clearable v-model="self_where.task_id" style="width: 200px"></el-input>
      </div>
      <div class="spacing">
        <el-input size="mini" placeholder="请输入流程名称"  clearable v-model="self_where.process_name" style="width: 200px"></el-input>
      </div>
      <div class="spacing">
        <el-input size="mini" placeholder="请输入流水号"  clearable v-model="self_where.serial_number" style="width: 200px"></el-input>
      </div>
      <div class="spacing">
        <el-input size="mini" placeholder="请输入发起人"  clearable v-model="self_where.promoter_user" style="width: 200px"></el-input>
      </div>
      <div class="spacing">
        <el-input size="mini" placeholder="请输入当前处理人"  clearable v-model="self_where.current_user" style="width: 200px"></el-input>
      </div>
      <div class="spacing">
        <el-date-picker
          v-model="self_where.date_range"
          size="mini"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="spacing">
        <el-select v-model="self_where.master_id" size="mini" clearable filterable placeholder="请选择">
          <el-option v-for="item in masterList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="spacing">
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
      </div>
      <div class="spacing">
        <el-button size="mini" type="success" @click="exportExecl">导出</el-button>
      </div>
    </div>
    <div class="table-wrap" style="width: 100%">
      <el-table :data="pageData.list" style="width: 100%">
        <el-table-column prop="task_id" label="ID" width="100"></el-table-column>
        <el-table-column prop="process_name" label="流程标题" width="400">
          <template slot-scope="scope">
            <el-link type="primary" @click="ERP.navigateTo('/flow/FlowView?sheet_id='+scope.row.sheet_id+'&task_id='+scope.row.task_id+'&master_id='+scope.row.master_id)">{{scope.row.process_name}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="serial_number" label="流水号" width="400"></el-table-column>
        <el-table-column prop="promoter_user" label="发起人" width=""></el-table-column>
        <el-table-column prop="curr_user" label="当前处理人" width=""></el-table-column>
        <el-table-column prop="finish_time" label="状态" width="">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_finish" type="success">已结束</el-tag>
            <el-tag v-if="!scope.row.is_finish" type="danger">在处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="发起时间" width=""></el-table-column>
        <el-table-column prop="finish_time" label="完成时间" width="">
          <template slot-scope="scope">
            <template v-if="scope.row.finish_time">
              {{  new Date(parseInt(scope.row.finish_time) * 1000).toLocaleString().replace(/\//g, '-') }}
            </template>
          </template>
        </el-table-column>
        <template>
          <el-table-column label="操作" width="">
            <template slot-scope="scope">
              <el-button v-if="oa_user_id != 189" type="primary" size="mini" @click="editFlowNode(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>

    <!--发起的审批单详情-->
    <el-dialog title="" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1200px">

      <el-descriptions title="" :column="2" border>
        <el-descriptions-item label="流程名称" labelStyle="width: 150px">
          {{ boxData.instForm.process_name }}
        </el-descriptions-item>
        <el-descriptions-item label="流程状态" labelStyle="width: 150px">
          <el-tag v-if="boxData.instForm.is_finish" type="success">已结束</el-tag>
          <el-tag v-if="!boxData.instForm.is_finish" type="danger">在处理</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="发起人" labelStyle="width: 150px">
          {{ boxData.instForm.initiator_user_name }}
        </el-descriptions-item>
        <el-descriptions-item label="发起时间" labelStyle="width: 150px">
          {{ boxData.instForm.create_time }}
        </el-descriptions-item>
        <el-descriptions-item label="选择共享人" labelStyle="width: 150px"></el-descriptions-item>
      </el-descriptions>

      <el-table :data="boxData.stepsData"
                border style="width: 100%; margin-top: 20px">
        <el-table-column prop="node_name" label="节点名称" width="200"></el-table-column>
        <el-table-column  label="审批类型" align="center">
          <template slot-scope="scope">
            <el-tag effect="dark"  v-if="scope.row.business_type === 3">审批</el-tag>
            <el-tag effect="dark" type="warning" v-if="scope.row.business_type === 4">会签</el-tag>
            <el-tag effect="dark" type="success" v-if="scope.row.business_type === 5">委托</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="action_user_name" label="审批人" align="center"></el-table-column>
<!--        <el-table-column label="状态" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <el-tag v-if="scope.row.is_handle === 1" type="success">已操作</el-tag>-->
<!--            <el-tag v-if="scope.row.is_handle === 0" type="danger">未操作</el-tag>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="select_action" label="审批结果" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.select_action === '同意' " type="success">同意</el-tag>
            <el-tag v-if="scope.row.select_action === '拒绝' " type="danger">拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column  label="完成时间" align="center">
          <template slot-scope="scope" v-if="scope.row.is_handle === 1">
            {{  new Date(parseInt(scope.row.handle_time) * 1000).toLocaleString().replace(/\//g, '-') }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.is_handle === 0
                    && scope.row.is_flow_handle === 1
                    && boxData.isFlowHandle" class="button-table" @click="flowHandle(scope.row)">审批</div>

            <div v-if="scope.row.is_handle === 0
                    && boxData.isFlowHandle" class="button-table" @click="editActionUser(scope.row, scope.$index)">修改审批人</div>

            <div v-if="scope.row.is_handle === 0
                    && boxData.isFlowHandle" class="button-table" @click="sendMsgToActionUser(scope.row)">提醒发送</div>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!--审批流程-->
    <el-dialog title="审批" :visible.sync="dialogVisibleApprove" :close-on-click-modal="false" width="800px">

      <el-descriptions title="" :column="2" border>
        <el-descriptions-item label="节点名称" labelStyle="width: 150px">
          {{ boxData.nodeData.node_name }}
        </el-descriptions-item>
        <el-descriptions-item label="审批人" labelStyle="width: 150px">
          {{ boxData.nodeData.action_user_name }}
        </el-descriptions-item>
        <el-descriptions-item label="审批类型" labelStyle="width: 150px">
            <el-tag effect="dark"  v-if="boxData.nodeData.business_type === 3">审批</el-tag>
            <el-tag effect="dark" type="warning" v-if="boxData.nodeData.business_type === 4">会签</el-tag>
            <el-tag effect="dark" type="success" v-if="boxData.nodeData.business_type === 5">委托</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="超时时长" labelStyle="width: 150px">
          {{ boxData.nodeData.timeout }}
        </el-descriptions-item>
      </el-descriptions>
      <div style="margin-top: 20px"></div>

      <el-descriptions :column="1" size="mini" border >
        <el-descriptions-item label="操作">
          <el-radio v-model="boxForm.handleForm.select_action" size="mini" label="同意">同意</el-radio>
          <el-radio v-model="boxForm.handleForm.select_action" size="mini" label="拒绝">拒绝</el-radio>
        </el-descriptions-item>
        <el-descriptions-item  label="意见">
          <el-input type="textarea" v-model="boxForm.handleForm.comments" placeholder="请填写意见……" maxlength="100" show-word-limit></el-input>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureHandleForm">确 定</el-button>
        <el-button @click="dialogVisibleApprove = false">取 消</el-button>
      </div>

    </el-dialog>
    <select-personnel ref="selectPersonnel" />
  </div>

</template>

<script>

import FlowTimeoutLog from "./components/FlowTimeoutLog";
import Http from "./common/Http";
import moment from "moment/moment";
import selectPersonnel from "../Personnel/components/selectPersonnel";

export default {
  name:"FlowAbnormal",
  components: {FlowTimeoutLog, selectPersonnel},
  data () {
    return {
      loading: false,
      dialogVisible:false,
      dialogVisibleApprove:false,
      self_where:{
        process_name: '',
        is_finish: 0,
        task_id:'',
        serial_number:'',
        promoter_user:'',
        current_user:'',
        date_range: [],
      },
      re_load_status:true,
      pageData:{
        list:[],
        total:0,
        pageSize:10,
        page:1
      },
      boxData:{
        instForm:{},
        stepsData:[],
        nodeData:{},
        isFlowHandle : true
      },
      boxForm:{},
      oa_user_id: 0,
      masterList: []
    }
  },
  created() {
    this.getList()
    this.getMasterList()
    this.initializeBoxForm()
    this.oa_user_id = window.localStorage.getItem('oa_user_id');
  },
  mounted() {
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      let that = this;
      Http.get("flow/FlowForm/instFormList",{
        where:JSON.stringify(that.self_where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData = res.data
        }
      })
    },
    getMasterList() {
      const that = this;
      let searchWhere = {page : 1, page_size : 1000};
      Http.get("flow/FlowMaster/getList",searchWhere,res=>{
        if(res.code) {
          that.masterList = res.data.list
        } else {
          that.masterList = {}
        }
      })
    },
    editFlowNode(row) {
      this.dialogVisible = true
      this.boxData.isFlowHandle = true

      let that = this
      that.boxData.instForm = row
      // 获取节点信息
      Http.get("flow/FlowProcessSteps/getProcessStepsListByTaskId",{
        task_id: row.task_id,
      },res=>{
        if(res.code) {
          // 流程节点存在已拒绝，则不能操作
          let list = res.data
          // 还未审批节点的数量
          let canHandleNodeCount = 0;
          for (let i=0; i < list.length; i++) {
            // 判断表单是否已拒绝
            if (list[i]['select_action'] === '拒绝') {
              that.boxData.isFlowHandle = false
            }
            if (list[i]['is_handle'] === 0) {
              canHandleNodeCount++
            }
            // 第一个未处理的节点可以审批流程
            if (canHandleNodeCount === 1) {
              list[i]['is_flow_handle'] = 1
            } else {
              list[i]['is_flow_handle'] = 0
            }
          }
          that.boxData.stepsData = list
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    exportExecl() {
      const that = this;
      that.loading=true;
      let where = that.self_where;
      Http.get("flow/FlowForm/exportExecl",{
        where:JSON.stringify(where),
      },res=>{
        if(res.code) {
          window.open(Http.getBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
        that.loading=false;
      })
    },
    // 流程审批
    flowHandle(row) {
      this.initializeBoxForm()

      this.boxForm.handleForm.step_id = row.id

      this.dialogVisibleApprove = true
      this.boxData.nodeData = row
      this.boxData.nodeData.timeout = '-'
      if (this.boxData.nodeData.is_handle === 0
          && this.boxData.nodeData.standard_finish_time > 0)
      {
        let diffTime = new Date().getTime() - parseInt(this.boxData.nodeData.standard_finish_time);
        if (diffTime > 0) {
          let d = moment.duration(diffTime, 'seconds');
          let str = '';
          if (d.asDays() > 1) str = str + d.asDays() + '天';
          if (d.hours() > 1) str = str + d.hours() + '时';
          if (d.minutes() > 1) str = str + d.minutes() + '分';
          if (d.seconds() > 1) str = str + d.seconds() + '秒';
          this.boxData.nodeData.timeout = str
        }
      }
    },
    // 确认流程审批
    sureHandleForm() {
      if (this.boxForm.handleForm.select_action === '' ) {
        this.$message.error('请选择同意或拒绝！');
        return false
      }
      // 提交审批
      const that = this;
      let data=JSON.parse(JSON.stringify(this.boxForm.handleForm));
      Http.post("flow/FlowHandle/handle",data,ret=>{
        if(ret.code){
          that.dialogVisible = false
          that.dialogVisibleApprove = false
          that.initializeBoxForm()
          that.$message.success("操作成功");
        }else {
          that.$message.error("提交数据出现异常");
        }
      })
    },
    // 修改审批人
    editActionUser(row, index) {
      const that = this;
      let config = {
        department_id:null,
          role_id:null,
          user_ids:null,
          user_len:1,
          type:"",
      }
      that.$refs.selectPersonnel.show(config,data=>{
        //限制只能单选
        if(data){
          let name = ''
          let select_user_id = 0
          data.map(ret=>{
            name = ret.name
            select_user_id = ret.id
          })
          let where = {
            step_id : row.id,
            select_user_id : select_user_id,
          }
          Http.post("flow/FlowProcessSteps/editStepsUser",where,ret=>{
            if(ret.code){
              that.dialogVisible = false
              that.dialogVisibleApprove = false
              that.initializeBoxForm()
              that.$message.success("操作成功");
            }else {
              that.$message.error("提交数据出现异常");
            }
          })
        }
      })
    },
    // 提醒审批人
    sendMsgToActionUser(row) {
      let that = this
      let data = {
        step_id : row.id,
      }
      Http.post("flow/FlowProcessSteps/sendMsg",data,ret=>{
        if(ret.code){
          that.dialogVisible =false
          that.dialogVisibleApprove = false
          that.$message.success("操作成功");
        }else {
          that.$message.error("操作失败");
        }
      })
    },
    initializeBoxForm() {
      this.boxForm = {
        handleForm: {
          select_action: '',
          comments: '',
          step_id: 0,
        }
      }
    }

  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}
.spacing {
  display: inline-block;
  margin-right: 10px;
  margin-top: 10px;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  //background: #99a9bf;
}
.bg-purple {
  //background: #d3dce6;
}
.bg-purple-light {
  //background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 80px;
}
.border {
  border: 1px solid #e8e8e8;
}
.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}
.button-table {
  color: #1867c0;
  cursor: pointer;
  display: inline-block;
  margin-left: 15px
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowAbnormal.vue